var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.icon,{tag:"component",class:[
    'dg-icon  fill-current',
    ("size-" + _vm.size),
    _vm.colorClass,
    _vm.hoverColorClass
  ],style:(Object.assign({}, {width: (_vm.size + "px")},
    _vm.gradientFill)),attrs:{"role":"img"}})}
var staticRenderFns = []

export { render, staticRenderFns }